import type { HTMLAttributes } from 'react';
import { inputCls, labelCls } from '../../../ui/styles';
type Props = {
  id: string;
  label: string;
  value: string;
  onChange: (v: string) => void;
  type?: string;
  autoComplete?: string;
  inputMode?: HTMLAttributes<HTMLInputElement>['inputMode'];
  error?: string;
};

/** Tekstveld voor Gegevens; een fout staat direct onder het veld en wordt mee voorgelezen. */
export function ProfileTextField({
  id,
  label,
  value,
  onChange,
  type = 'text',
  autoComplete,
  inputMode,
  error
}: Props) {
  const errorId = `${id}-error`;
  return <div data-id="element-6793" data-mp="2b4smngpab3p3">
      <label htmlFor={id} className={labelCls} data-id="element-6794" data-mp="2b40s897fbc0e">
        {label}
      </label>
      <input id={id} type={type} value={value} autoComplete={autoComplete} inputMode={inputMode} onChange={e => onChange(e.target.value)} aria-invalid={error ? true : undefined} aria-describedby={error ? errorId : undefined} className={inputCls} data-id="element-6795" data-mp="267il52omf1kw" />
      {error && <p id={errorId} className="mt-1.5 text-[13px] text-clay" data-id="element-6796" data-mp="pnsden3g69zl">
          {error}
        </p>}
    </div>;
}